import React from "react";
import PropTypes from "prop-types";
import completeIcon from "assets/images/complete-icon.svg";

import styles from "./atoms.Wizard.StepProgress.module.scss";
export class Wizard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: this.props.activeStep,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeStep !== prevProps.activeStep) {
        this.setState({
          activeStep: this.props.activeStep,
        })
    }
  }

  onClickHandler = (e) => {
    if(this.props.isNavigable) {
      const step = this.props.steps.find(step => step.id === e.target.id);
      if(step?.id < this.state.activeStep) {
        step?.onClick?.();
      }
    };

    if (! this.props.clickEnabled) {
      return;
    }

    e.preventDefault();
    this.setState({
      activeStep: e.target.id,
    });
    if (this.props.handler) this.props.handler(e.target.id);
  };

  render() {
    const { steps, isNavigable } = this.props;

    return (
      <div className={styles["wizard-container"]}>
        {/* <div className="step-line-general"></div> */}
        <div className={styles["wizard-step-wrapper"]}>
          {steps.map((step) => {
            return (
              <div className={styles["step-wrapper"]} key={step.id}>
                <div className={
                  this.state.activeStep === step.id
                    ? `${styles["name"]} ${styles["active"]}`
                    : styles["name"]
                }>
                  {step.name}
                </div>
                <div
                  className={styles["step-point"]}
                  onClick={this.onClickHandler}
                  id={step.id}
                  data-automation-id="step"
                >
                  
                  <div className={`${styles["step-line"]} ${styles["step-line-left"]}`}></div>
                  
                  <div
                   className={
                      this.state.activeStep === step.id
                        ? styles["outer-point-active"]
                        : styles["outer-point"]
                    }
                    style={{ cursor: isNavigable && this.state.activeStep > step.id  ? "pointer" : "default" }}
                    onClick={this.onClickHandler}
                    data-automation-id="step"
                    id={step.id}
                  >
                    <div
                      className={
                        this.state.activeStep >= step.id
                          ? styles["inner-point-active"]
                          : styles["inner-point"]
                      }
                      id={step.id}
                      onClick={this.onClickHandler}
                      data-automation-id="step"
                    >
                      {this.state.activeStep > step.id && <img src={completeIcon} draggable={false} id={step.id} />}
                    </div>
                  </div>

                  <div className={`${styles["step-line"]} ${styles["step-line-right"]}`}></div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    );
  }
}

Wizard.propTypes = {
  steps: PropTypes.array,
  activeStep: PropTypes.string,
  handler: PropTypes.func,
  isNavigable: PropTypes.bool
};

export default Wizard;
